import { render, staticRenderFns } from "./abilityEditDetail.vue?vue&type=template&id=4d87d702&scoped=true"
import script from "./abilityEditDetail.vue?vue&type=script&lang=js"
export * from "./abilityEditDetail.vue?vue&type=script&lang=js"
import style0 from "./abilityEditDetail.vue?vue&type=style&index=0&id=4d87d702&prod&lang=scss&scoped=true"
import style1 from "./abilityEditDetail.vue?vue&type=style&index=1&id=4d87d702&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d87d702",
  null
  
)

export default component.exports